// Copyright (c) 2020 Deere & Company

import PlaceholderOption from './placeholder-option';
import PropTypes from 'prop-types';
import React from 'react';

function handleChange ( event ) {

    if ( this.alwaysCallOnChange ) {

        this.onChange( event.target.value );

    } else if ( event.target.value ) {

        this.onChange( event.target.value );

    }

}

const SelectList = props => (
    <select
        className={`options-drop-down ${props.disabled ? 'disable-cls' : ''}`}
        onChange={handleChange.bind( props )}
        value={props.selectedValue ?? ''}
        disabled={props.disabled}
    >
        {props.showPlaceholder && (
            <PlaceholderOption
                isTranslated={props.isPlaceholderTranslated}
                text={props.placeholder}
            />
        )}
        {props.options.map( ( option, index ) => (
            <option
                key={`${option[props.optionKey]}-${index}`}
                value={option[props.optionKey]}
            >
                {props.optionDisplayAttributes
                    .map( attribute => option[attribute] )
                    .join( ' - ' )
                }
            </option>
        ) )}
    </select>
);

SelectList.displayName = 'SelectList';
SelectList.propTypes = {
    alwaysCallOnChange: PropTypes.bool.isRequired,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf( PropTypes.string ).isRequired,
    optionKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf( PropTypes.object ).isRequired,
    placeholder: PropTypes.string,
    selectedValue: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    showPlaceholder: PropTypes.bool,
    disabled: PropTypes.bool
};
SelectList.defaultProps = {
    showPlaceholder: true,
    selectedValue: ''
};

export default SelectList;
